import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

export default function RoketPartnerSection() {
  const { lang } = useLang();
  const t = HOME_I18N[lang].partner;

  return (
    <section className="section relative overflow-hidden bg-white" data-testid="partner-section">
      <div className="container-x relative grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <span className="eyebrow">{t.eyebrow}</span>
          <h2 className="mt-3 h2-section">
            {t.title1}<br />
            <span className="text-[#2563EB]">{t.titleAccent}</span>
          </h2>
          <p className="mt-5 body-lg max-w-2xl">{t.desc}</p>

          <ul className="mt-8 grid gap-3 sm:grid-cols-2 max-w-2xl" data-testid="partner-advantages">
            {t.items.map((a, i) => (
              <motion.li
                key={a}
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.04 }}
                className="flex items-start gap-3 rounded-xl border border-slate-200 bg-[#F8FAFC] p-3.5"
              >
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-[#10B981]/15 text-[#10B981]">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
                <span className="text-sm font-medium text-[#07111F]">{a}</span>
              </motion.li>
            ))}
          </ul>

          <div className="mt-8">
            <Link to="/proje-talep" data-testid="partner-cta" className="btn-primary">
              {t.cta}
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative rounded-3xl border border-slate-200 bg-[#07111F] p-8 text-white overflow-hidden">
            <div className="absolute inset-0 bg-grid opacity-20" />
            <div className="absolute -top-16 right-0 h-48 w-48 rounded-full bg-[#2563EB]/25 blur-[90px]" />
            <div className="relative grid grid-cols-2 gap-4">
              {t.proof.map((s) => (
                <div key={s.l} className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur">
                  <div className="font-heading text-2xl font-extrabold text-white leading-none">{s.v}</div>
                  <div className="mt-2 text-xs leading-snug text-white/55">{s.l}</div>
                </div>
              ))}
            </div>
            <p className="relative mt-6 text-xs text-white/40">{t.note}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
